import React, { useState } from "react";
import { FormLogin } from "./formLogin";
import { FormRecover } from "./formRecover";
import { Alert } from "../../components/alert";
import { AccessLayout } from "./accessLayout";

export default function Login() {
  const [recover, setRecover] = useState(false);
  return <><AccessLayout
    title={recover ? "Recuperar contraseña" : "Entra a tu negocio"}
    eyebrow={recover ? "RECUPERA TU ACCESO" : "BIENVENIDO DE NUEVO"}
    intro={recover ? "Introduce el email que utilizas para administrar este negocio." : "Inicia sesión para gestionar tu día a día."}
    onBack={recover ? () => setRecover(false) : undefined}>
    {recover ? <FormRecover /> : <FormLogin callback={() => setRecover(true)} />}
  </AccessLayout><Alert /></>;
}
